/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPoly = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m18.636 7.94 3.584 1.956-3.567 10.38-7.316 1.872-2.933-4.61-4.602 1.69-.218-1.162a495.69 495.69 0 0 1-1.037-5.71c-.167-.958-.313-1.83-.411-2.474-.049-.32-.088-.594-.11-.797A4.155 4.155 0 0 1 2 8.797a1.524 1.524 0 0 1 .003-.18c.003-.036.01-.104.03-.184.011-.044.066-.27.267-.471l4.698-4.416.219-.204.295-.052 8.1-1.402zM8.148 5.21 5.506 7.69 4.26 8.862l-.219.205c.019.14.04.313.071.514.095.622.24 1.478.406 2.432.254 1.462.56 3.138.816 4.521l3.895-1.428 3.017 4.745 4.866-1.245 2.667-7.762-2.65-1.448-.14-.28-2.502-5.005z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPoly as Poly };
